import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from "@angular/core";
import { Organisation } from "@common/ADAPT.Common.Model/organisation/organisation";
import { ProgressProduct } from "@common/ADAPT.Common.Model/organisation/progress-product";
import { Autobind } from "@common/lib/autobind.decorator/autobind.decorator";
import { ProgressService } from "@common/progress/progress.service";
import { BaseComponent } from "@common/ux/base.component/base.component";

@Component({
    selector: "adapt-select-progress-products",
    standalone: false,
    templateUrl: "./select-progress-products.component.html",
})
export class SelectProgressProductsComponent extends BaseComponent implements OnInit, OnChanges {
    @Input() public progressProductIds: number[] = [];
    @Output() public progressProductIdsChange = new EventEmitter<number[]>();
    public templateProgressProducts: ProgressProduct[] = [];

    @Input() public organisation?: Organisation;
    public organisationProducts: ProgressProduct[] = [];

    public constructor(private progressService: ProgressService) {
        super();
    }

    public get existingProducts() {
        return this.progressProducts.filter((p) =>
            this.organisationProducts.some((op) => op.code === p.code || op.name === p.name));
    }

    public get progressProducts() {
        return this.progressProductIds.map((id) => this.templateProgressProducts.find((p) => p.progressProductId === id))
            .filter((p) => !!p);
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.organisation) {
            this.progressService.getProgressProducts(this.organisation?.organisationId).pipe(
                this.takeUntilDestroyed(),
            ).subscribe((organisationProducts) => this.organisationProducts = organisationProducts);
        }
    }

    public ngOnInit() {
        this.progressService.getTemplateProgressProducts().pipe(
            this.takeUntilDestroyed(),
        ).subscribe((progressProducts) => {
            // hide products with no categories defined
            this.templateProgressProducts = progressProducts.filter((p) => p.progressCategories.length > 0);
        });
    }

    @Autobind
    public progressProductDisplayExpr(row: ProgressProduct) {
        return `${row.name} (${row.code})`;
    }

    public onValueChanged(values: number[]) {
        this.progressProductIdsChange.emit(values);
    }
}
